var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { space, color, display, fontSize, lineHeight, justifyContent, flexDirection, textAlign, } from 'styled-system';
import { breakpoint } from '../../common/theme/helper';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { useLocalization } from '../../common/providers/LocaleProvider';
import { Grid, GridItem } from '../../common/components/Grid';
import { UspBarRichText, UspBarPlainText, Link, Text } from './UspBarText';
var UspBarContainer = styled(GridItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, justifyContent, flexDirection);
UspBarContainer.defaultProps = {
    display: ['none', null, 'flex'],
    justifyContent: 'space-between',
};
var UspBarText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-transform: ", ";\n  letter-spacing: 1px;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-transform: ", ";\n  letter-spacing: 1px;\n"])), color, space, fontSize, lineHeight, textAlign, function (props) { return props.textTransform; });
UspBarText.defaultProps = {
    color: 'gray.9',
    my: [1, null, 2],
    mx: 0,
    fontSize: '11px',
    lineHeight: 1,
    textTransform: 'uppercase',
};
var UspBarContent = styled(UspBarText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  letter-spacing: normal;\n\n  & {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: 13px;\n      font-weight: bold;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n  }\n\n  & p {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n"], ["\n  letter-spacing: normal;\n\n  & {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: 13px;\n      font-weight: bold;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n  }\n\n  & p {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n"])));
UspBarContent.defaultProps = __assign(__assign({}, UspBarText.defaultProps), { as: 'div' });
var UspBarButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline;\n  text-decoration: underline;\n  letter-spacing: normal;\n  font-size: 11px;\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: 0;\n  color: inherit;\n\n  &[disabled] {\n    visibility: hidden;\n  }\n"], ["\n  display: inline;\n  text-decoration: underline;\n  letter-spacing: normal;\n  font-size: 11px;\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: 0;\n  color: inherit;\n\n  &[disabled] {\n    visibility: hidden;\n  }\n"])));
var MobileInstalmentUspBar = /** @class */ (function (_super) {
    __extends(MobileInstalmentUspBar, _super);
    function MobileInstalmentUspBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isOpen: false };
        return _this;
    }
    MobileInstalmentUspBar.prototype.show = function () {
        this.setState({ isOpen: true });
    };
    MobileInstalmentUspBar.prototype.hide = function () {
        this.setState({ isOpen: false });
    };
    MobileInstalmentUspBar.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement(Grid, { legacyShopRebootMaxWidth: props.legacyShopRebootMaxWidth, bg: "gray.9" },
            React.createElement(UspBarContainer, { display: ['block', null, 'none'] },
                React.createElement(UspBarText, { textAlign: "center", color: "gray.3", textTransform: "none" },
                    props.instalmentPromoText,
                    ' ',
                    React.createElement(UspBarButton, __assign({}, getTrackerProps({
                        onClick: function () { return _this.show(); },
                        'data-testid': 'more-info-button',
                        disabled: this.state.isOpen,
                    }, {
                        event: 'headerTracking',
                        eventData: {
                            placement: 'uspBar',
                            labelIdentifier: 'h24_more_info',
                        },
                    })), props.moreInfoLabel))),
            React.createElement(UspBarContainer, { display: [this.state.isOpen ? 'block' : 'none', null, 'none'], flexDirection: "column" },
                React.createElement(UspBarContent, { "data-testid": "legal-text", textTransform: "none", color: "gray.3", dangerouslySetInnerHTML: {
                        __html: props.instalmentLegalText,
                    } }),
                React.createElement(UspBarContent, { color: "gray.3", textAlign: "right" },
                    React.createElement(UspBarButton, __assign({}, getTrackerProps({
                        onClick: function () { return _this.hide(); },
                        'data-testid': 'close-button',
                    }, {
                        event: 'headerTracking',
                        eventData: {
                            placement: 'uspBar',
                            labelIdentifier: 'h24_close',
                        },
                    })), props.hideLabel)))));
    };
    return MobileInstalmentUspBar;
}(React.Component));
// disabled because of https://home24.atlassian.net/browse/FP-523
var SHOW_INSTALLMENT_USP_BAR = false;
var UspBarDisplayController = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: ", ";\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n"], ["\n  display: ", ";\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n"])), function (_a) {
    var visibleOnSmall = _a.visibleOnSmall;
    return (visibleOnSmall ? 'block' : 'none');
}, breakpoint(0), function (_a) {
    var visibleOnMedium = _a.visibleOnMedium;
    return (visibleOnMedium ? 'block' : 'none');
}, breakpoint(1), function (_a) {
    var visibleOnLarge = _a.visibleOnLarge;
    return (visibleOnLarge ? 'block' : 'none');
});
var uspBarTrackingEvent = {
    event: 'headerTracking',
    eventData: {
        placement: 'uspBar',
        labelIdentifier: 'h24_usp_bar_link',
        listIndex: 0,
        listLength: 1,
    },
};
var UspBar = function (_a) {
    var _b, _c;
    var text = _a.text, link = _a.link, textHtml = _a.textHtml, textColor = _a.textColor, backgroundColor = _a.backgroundColor, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, visibilityProps = __rest(_a, ["text", "link", "textHtml", "textColor", "backgroundColor", "__legacy_shop_reboot_max_width"]);
    var _d = useLocalization(), t = _d.t, region = _d.region, theme = _d.theme;
    var shouldRenderPlainText = !!text;
    return (React.createElement(React.Fragment, null,
        React.createElement(UspBarDisplayController, __assign({}, visibilityProps),
            React.createElement(Grid, { "data-testid": "usp-bar-grid", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, bg: backgroundColor },
                React.createElement(UspBarContainer, { "data-testid": "usp-bar-container", justifyContent: "center", display: "flex" }, shouldRenderPlainText ? (React.createElement(UspBarPlainText, { "data-testid": "usp-bar-plain-text" }, ((_b = link) === null || _b === void 0 ? void 0 : _b.url) ? (React.createElement(Link, __assign({}, getTrackerProps({
                    href: (_c = link) === null || _c === void 0 ? void 0 : _c.url,
                    color: textColor,
                }, uspBarTrackingEvent)), text)) : (React.createElement(Text, { color: textColor }, text)))) : (React.createElement(UspBarRichText, __assign({}, getTrackerProps({
                    'data-testid': 'usp-bar-rich-text',
                    color: textColor,
                    dangerouslySetInnerHTML: { __html: textHtml },
                }, uspBarTrackingEvent))))))),
        SHOW_INSTALLMENT_USP_BAR && region === 'DE' && theme === 'h24' && (React.createElement(MobileInstalmentUspBar, { instalmentPromoText: t('h24_instalment_promo_text'), moreInfoLabel: t('h24_more_info'), instalmentLegalText: t('h24_instalment_promo_legal_text'), hideLabel: t('h24_close'), legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width }))));
};
export default UspBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
